import {
  GIPHY_SLIDER_PANEL,
  ICONS_SLIDER_PANEL,
  IMAGES_SLIDER_PANEL,
  MUSIC_SLIDER_PANEL,
  PROJECTS_SLIDER_PANEL,
  VIDEO_SLIDER_PANEL,
} from "../_components/details/constants";
import { AssetProcessingStatusTypes } from "./constants";

/**
 * Media Panel utilities
 */

export const getSourceKeyFromPanelType = (panelType) => {
  switch (panelType) {
    case ICONS_SLIDER_PANEL:
      return "iconsSource";
    case IMAGES_SLIDER_PANEL:
      return "imageSource";
    case VIDEO_SLIDER_PANEL:
      return "videoSource";
    case MUSIC_SLIDER_PANEL:
      return "musicSource";
    case PROJECTS_SLIDER_PANEL:
      return "projectsSource";
    case GIPHY_SLIDER_PANEL:
      return "gifSource";
    default:
      return null;
  }
};

export const isActivePanel = (getState, panelType) => {
  const sliderState = getState().sidebarSlider;
  return sliderState.sliderPanelType === panelType;
};

export const isActiveSourceAndPanel = (getState, panelType, panelSource) => {
  const sourceKey = getSourceKeyFromPanelType(panelType);
  const sliderState = getState().sidebarSlider;
  return (
    sliderState.sliderPanelType === panelType &&
    sliderState[sourceKey] === panelSource
  );
};

export const getAssetMessageFromAssetProcessingStatus = (status) => {
  switch (status) {
    case AssetProcessingStatusTypes.NOT_STARTED:
      return "asset_status.asset_processing";
    case AssetProcessingStatusTypes.IN_PROGRESS:
      return "asset_status.asset_processing";
    case AssetProcessingStatusTypes.PROCESSING_FAILED:
      return "asset_status.asset_failed";
    case AssetProcessingStatusTypes.THUMBNAIL_FAILED:
      return "asset_status.asset_thumb_failed";
    default:
      return null;
  }
};

export const getCursorTypeFromAssetProcessingStatus = (status) => {
  switch (status) {
    case AssetProcessingStatusTypes.NOT_STARTED:
    case AssetProcessingStatusTypes.IN_PROGRESS:
      return "progress";
    case AssetProcessingStatusTypes.PROCESSING_FAILED:
      return "not-allowed";
    case AssetProcessingStatusTypes.THUMBNAIL_FAILED:
      return "help";
    default:
      return "pointer";
  }
};
